import { twMerge } from 'tailwind-merge';
import { GenericTabButton } from './GenericTabButton';

type GenericTabNavigatorProps = {
  activeTabId: number;
  onTabChange: (tabId: number, tabName: string) => void;
  tabNames: string[];
  className: string;
};

export const GenericTabNavigator = ({
  activeTabId,
  onTabChange,
  tabNames,
  className,
}: GenericTabNavigatorProps): React.ReactNode => (
  <div className={twMerge('flex gap-5', className)}>
    {tabNames.map((name, index) => (
      <GenericTabButton
        key={name}
        handleChangeTab={(): void => onTabChange(index, name)}
        label={name}
        active={activeTabId === index}
      />
    ))}
  </div>
);
